import { ResetPinModal } from "src/components/DocViewer/components/docInfoDrawer/approversTab/pin/ResetPinModal";

const PinReset = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center h-full">
      <ResetPinModal isOpen={true} />
    </div>
  );
};

export default PinReset;
